import { useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import TableMUI from "../TableMUI/TableMUI";
import { productsTableColumns } from "../TableMUI/TableColumns";
import PopupTemplate from "../PopupTemplate/PopupTemplate";
import { DeleteBrandProduct } from "../../../API/endpoints/Brands";
import AddEditProductModal from "../../Brands/components/AddEditProductModal";

function ProductList(props: {
  rows: any[];
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  dataCount: number;
  setSearchParam: React.Dispatch<React.SetStateAction<string>>;
  refresh: boolean;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  brandList: {
    name: string;
    value: string;
    categories: { focus_category: string; sub_categories: string[] }[];
  }[];
  selectedBrand?: string;
  userType: string | undefined;
}) {
  const [productID, setProductID] = useState<string>("");
  const [showDeleteProduct, setShowDeleteProduct] = useState(false);
  const [showAddEditProductModal, setShowAddEditProductModal] = useState("");
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const columns = productsTableColumns(
    setProductID,
    setShowDeleteProduct,
    setShowAddEditProductModal,
    props.userType,
    setSelectedProduct
  );

  const handleClose = () => {
    setProductID("");
    setShowDeleteProduct(false);
  };

  const handleDeleteProduct = async () => {
    await DeleteBrandProduct(productID);
    handleClose();
    props.setRefresh((prev) => !prev);
  };

  console.log("selectedProduct", selectedProduct);

  const handleCloseAddEditProductModal = () => {
    setShowAddEditProductModal("");
    setSelectedProduct(null);
  };

  return (
    <div className="p-4 rounded-[8px] bg-white">
      <div className="d-flex justify-between items-center mb-4">
        <InputGroup size="sm" className="input-search">
          <InputGroup.Text id="inputGroup-sizing-sm">
            <img src="../svgs/lenseicon.svg" alt="searchicon" />
          </InputGroup.Text>
          <Form.Control
            aria-label="Small"
            aria-describedby="inputGroup-sizing-sm"
            placeholder="Search Products"
            onChange={(e) => {
              props.setSearchParam(e.target.value);
            }}
          />
        </InputGroup>
        {
          <Button
            onClick={() => setShowAddEditProductModal("Add")}
            className="btn-primary12 bg-[#0152FB]"
          >
            Add New
          </Button>
        }
      </div>
      <div className="TableMUIcountainer">
        <TableMUI
          columns={columns}
          rows={props.rows}
          dataCount={props.dataCount}
          setListPage={() => props.setPage}
          listPage={props.page}
        />
      </div>
      <PopupTemplate
        popupHeader={"Confirm Delete"}
        popupBody={"Are you sure you want to delete this product?"}
        handleFunction={handleDeleteProduct}
        isModalOpen={showDeleteProduct}
        onCancel={handleClose}
        id={productID}
        isRestore={false}
      />
      <AddEditProductModal
        isModalOpen={showAddEditProductModal}
        handleCloseModal={handleCloseAddEditProductModal}
        setRefresh={props.setRefresh}
        brandList={props.brandList}
        defaultBrand={props?.selectedBrand}
        selectedProduct={selectedProduct}
      />
    </div>
  );
}

export default ProductList;
